import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  @Input() profileImage: string;
  doctype:any;
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.authDataSubject.pipe(take(1)).subscribe(authData => {
      this.doctype = authData._type
    }
  )}
  onClickLogout() {
    this.authService.onLogout();
  }
}
